import { useTranslation } from 'react-i18next';

import { Drawer } from 'components/shared';
import { StyledDrawerBox } from 'components/shared/CRUD/TableCRUDLayout.styles';
import ProtocolForm from '../ProtocolForm';

import type { ProtocolDrawerProps } from './ProtocolDrawer.types';

/** Slides in from the right, for a new protocol and for editing one from its detail view */
const ProtocolDrawer = ({
  open,
  protocol,
  onClose,
  onSaved
}: ProtocolDrawerProps) => {
  'use memo';
  const { t } = useTranslation('common');

  return (
    <Drawer
      open={open}
      onClose={onClose}
      title={
        protocol
          ? t('adminPortal.protocols.form.editTitle')
          : t('adminPortal.protocols.form.createTitle')
      }
    >
      <StyledDrawerBox>
        <ProtocolForm protocol={protocol} onSaved={onSaved} />
      </StyledDrawerBox>
    </Drawer>
  );
};

export default ProtocolDrawer;
